import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { cartutils } from "../../Helpers";
import CartInfluencer from "./Common/CartInfluencer";
import { Trash2 } from "lucide-react";
import { hasPermission } from "../Constants/AppConstant";
import ModalNotSubscribe from "./Common/Modal/ModalNotSubscribe";
import { SwitchWithLabel } from "../AppSwitchWithLabel";
import CryptoJS from "crypto-js";
import { storageHandler } from "../../Helpers";

export default function Cart({
  user,
  updateProfilePage,
  setUpdateProfilePage,
  subTotalAmt,
  setSubTotalAmt,
  setTotalToPay,
  totalToPay,
  availableBalance,
  setCartItem,
  showCart,
  cartItem,
  setShowCart,
  removeCartItem,
}) {
  const navigate = useNavigate();
  const [projected, setProjected] = useState(0);
  const [cartItemSaved, setCartItemSaved] = useState([]);
  console.log("🚀 ~ Cart ~ cartItemSaved:", cartItemSaved);
  const [isSubscribeModal, setIsSubscribeModal] = useState(false);
    // eslint-disable-next-line
  const [confirmDeleteIndex, setConfirmDeleteIndex] = useState(null);

  useEffect(() => {
    const getcartItem = cartutils.getCartItemInArray(user.data.id);
    setCartItemSaved(getcartItem);

    const subtotalVal = cartutils.calSubTotal(getcartItem);
    setSubTotalAmt(subtotalVal);
    setProjected(subtotalVal / 2);

    if (availableBalance) {
      const deductedFromAvailableBalance =
        cartutils.calDeductionFromavailableBalance(
          subtotalVal,
          availableBalance
        );
      const caltotalToPay = cartutils.calTotalToPay(
        subtotalVal,
        deductedFromAvailableBalance
      );
      setTotalToPay(caltotalToPay);
    }
  }, [
    cartItem,
    showCart,
    availableBalance,
    user.data.id,
    setSubTotalAmt,
    setTotalToPay,
  ]);

  const exploreInfluencer = () => {
    setShowCart(false);
    navigate("/brand/influencerdiscovery");
  };

  const placeOrder = () => {
    if (hasPermission(12)) {
      navigate("/brand/placeorder");
    } else {
      setIsSubscribeModal(true);
    }
  };

  const handleDirectDelete = (index) => {
    removeCartItem(index);
  };

  const encryptData = (data, secretKey) => {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  const handlePaymentToggle = (index, checked) => {
    const updatedCart = [...cartItemSaved];
    updatedCart[index].tama_payment = checked ? 1 : 0;
    setCartItemSaved(updatedCart);

    // Update localStorage
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedData = encryptData(JSON.stringify(updatedCart), secretKey);
    storageHandler.setCartItem(encryptedData);
  };

  return (
    <>
      <div
        className={`fixed inset-0 z-[1000] transition-opacity duration-300 ${
          showCart ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black/50"
          onClick={() => {
            setShowCart(false);
            setConfirmDeleteIndex(null);
          }}
        />

        {/* Cart Sidebar */}
        <div
          className={`fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
            showCart ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex flex-col h-full">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b">
              <h2 className="text-2xl font-bold">Cart</h2>
              <button
                onClick={() => {
                  setShowCart(false);
                  setConfirmDeleteIndex(null);
                }}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z"
                  />
                </svg>
              </button>
            </div>

            {/* Cart Content */}
            <div
              className="flex-1 overflow-y-auto p-4"
              style={{
                scrollbarWidth: "thin",
                scrollbarColor: "#e5e7eb transparent",
              }}
            >
              {cartItemSaved?.length > 0 ? (
                <div className="space-y-6">
                  {/* Cart Items */}
                  <div className="space-y-4">
                    {cartItemSaved?.map((cartItemLoop, index) => (
                      <div
                        key={index}
                        className="pb-4 border-b border-gray-200 relative"
                      >
                        <div className="flex gap-4 justify-between">
                          <div className="flex-1">
                            <CartInfluencer
                              cartItemLoop={cartItemLoop}
                              updateProfilePage={updateProfilePage}
                              setUpdateProfilePage={setUpdateProfilePage}
                            />
                            <div className="mt-4 p-1 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border border-green-100">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-3">
                                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                                    <svg
                                      className="w-4 h-4 text-green-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <div>
                                    <p className="text-sm font-medium text-gray-900">
                                      Payments Handled By TAMA
                                    </p>
                                    {/* <p className="text-xs text-gray-500">
                                      Let Tama handle the payment process
                                    </p> */}
                                  </div>
                                </div>
                                <SwitchWithLabel
                                  id={`payment-${index}`}
                                  label=""
                                  labelRight=""
                                  className=""
                                  checked={cartItemLoop.tama_payment === 1}
                                  onCheckedChange={(checked) =>
                                    handlePaymentToggle(index, checked)
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          {/* Delete Button */}
                          <button
                            onClick={() => handleDirectDelete(index)}
                            className="text-red-600 hover:text-red-800 hover:bg-red-50 p-2 rounded-lg transition-all self-start mt-3"
                            title="Remove item"
                          >
                            <Trash2 size={20} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Pricing Section */}
                  <div className="space-y-4">
                    {cartItemSaved.some((item) => item.tama_payment === 1) && (
                      <div className="flex justify-between">
                        <span className="text-black-700 font-bold text-lg">
                          Subtotal
                        </span>
                        <span className="text-black-700 font-bold text-lg">
                          $
                          {cartItemSaved
                            ?.filter((item) => item.tama_payment === 1)
                            ?.reduce(
                              (sum, item) => sum + parseFloat(item.price),
                              0
                            )
                            ?.toFixed(2)}
                        </span>
                      </div>
                    )}

                    {cartItemSaved.some((item) => item.tama_payment === 0) && (
                      <div className="flex justify-between">
                        <span className="text-blue-700 font-bold text-lg">
                          You Pay Influencer Directly
                        </span>
                        <span className="text-blue-700 font-bold text-lg">
                          $
                          {cartItemSaved
                            ?.filter((item) => item.tama_payment === 0)
                            ?.reduce(
                              (sum, item) => sum + parseFloat(item.price),
                              0
                            )
                            ?.toFixed(2)}
                        </span>
                      </div>
                    )}

                    {cartItemSaved.length >= 2 && (
                      <>
                        <div className="flex justify-between">
                          <span className="text-green-700 font-bold text-lg">
                            Projected Spend
                          </span>
                          <span className="text-green-700 font-bold text-lg">
                            ${projected.toFixed(2)}
                          </span>
                        </div>
                        <div className="text-sm text-gray-500 p-3 bg-gray-50 rounded-lg">
                          On average,{" "}
                          <b className="text-gray-700">
                            50% of offers are accepted
                          </b>
                          . Therefore, your projected spend is{" "}
                          <span className="font-medium">
                            ${projected.toFixed(2)}
                          </span>
                          . Your total spend can still be reached if all offers
                          are accepted.
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : (
                // Empty Cart
                <div className="flex flex-col items-center justify-center h-full text-center py-8">
                  <div className="mb-4 text-gray-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-16 w-16 mx-auto"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={1.5}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-medium text-gray-900 mb-2">
                    Cart is empty
                  </h3>
                  <p className="text-gray-500 mb-6 max-w-xs">
                    Start adding influencers by clicking the button below
                  </p>
                  <button
                    onClick={exploreInfluencer}
                    className="px-6 py-3 bg-green-700 text-white font-medium rounded-full hover:bg-green-800 transition-colors"
                  >
                    Explore Influencers
                  </button>
                </div>
              )}
            </div>

            {/* Footer */}
            {cartItemSaved.length > 0 && (
              <div className="p-4 border-t">
                <button
                  onClick={placeOrder}
                  className="w-full py-3 px-4 bg-green-700 text-white font-bold rounded-full hover:bg-green-800 transition-colors"
                >
                  Checkout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {isSubscribeModal && (
        <ModalNotSubscribe
          goToPricing={() => navigate("/brand/pricing")}
          type="brand"
          // setAuth={setAuth}
          // setModal={setModal}
          // NotifModul={NotifModul}
          // setNotifModul={setModalNotification}
          // profiles={profiles}
          // closeCartPanel={closeCartPanel}
          // user={user}
          // cartItem={cartItem}
          title={"Direct Campaigns"}
          onClose={() => setIsSubscribeModal(false)}
          // background={"background_inflist.png"}
        />
      )}
    </>
  );
}
